import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import InternalBackLink from '../Internal/InternalBackLink';
import { readTheme } from '../../utils/internalTheme';
import './InternalIndex.css';

/**
 * Proposals sub-index — list of proposal / opportunity docs.
 * Blueprint: docs/INTERNAL_PROPOSALS.md
 */

/** @see docs/INTERNAL_PROPOSALS.md — Docs list */
const DOCS = [
  {
    num: '01',
    key: 'speckle-roi',
    href: '/xlabs/speckle-case',
    name: 'Speckle ROI analysis',
    sub: 'Business case · cost · ROI math',
  },
  {
    num: '02',
    key: 'utah',
    href: '/internal/adu-utah-pjm',
    name: 'Utah opportunity',
    sub: 'ADU Utah project canvas',
  },
];

export default function InternalProposals() {
  const [theme, setTheme] = useState(readTheme);

  useEffect(() => {
    const onTheme = (e) => {
      if (typeof e.detail === 'string') setTheme(e.detail);
      else setTheme(readTheme());
    };
    window.addEventListener('construx-internal-theme', onTheme);
    return () => window.removeEventListener('construx-internal-theme', onTheme);
  }, []);

  return (
    <div
      className="internal-index"
      data-hub-theme={theme === 'light' ? undefined : theme}
    >
      <Helmet>
        <title>proposals · internal</title>
        <link
          href="https://fonts.googleapis.com/css2?family=Inter+Tight:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <div className="hub">
        <div className="hub-card">
          <div className="hub-h">
            <InternalBackLink />
          </div>
          <h1 className="hub-title">Proposals</h1>
          <p className="hub-sub">Opportunity and analysis docs.</p>

          <div className="nav-grid">
            {DOCS.map((d) => (
              <Link key={d.key} className="card" to={d.href}>
                <span className="num">{d.num}</span>
                <span className="name">{d.name}</span>
                <span className="sub">{d.sub}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
